import React from 'react';

import AppBase from '@common/ui/AppBase';
import { getRoutes } from './utils/routes';
import { RoutesGenerator } from '@common/ui/router';
import '@vectord/ui/dist/style.css';
import '@vectord/fp-styles/dist/style.css';
import './main.module.scss';
import './styles/index.scss';

function App() {
  const routerDetails = getRoutes();

  return (
    <div className="scaler">
      <AppBase renderSingletons>
        <RoutesGenerator {...routerDetails} />
      </AppBase>
    </div>
  );
}

export default App;
